<template>
  <b-container id="login">
    <b-row align-h="center" class="mt-5">
      <b-col cols="md-6 lg-4 xl-3">
        <b-jumbotron>
          <b-form @submit.prevent="doLogin">
            <b-form-group
              id="emailInputGroup"
              label="E-Mail"
              label-for="emailInput"
            >
              <b-form-input
                id="emailInput"
                type="email"
                v-model="form.email"
                required
              ></b-form-input>
            </b-form-group>
            <b-form-group
              id="passwordInputGroup"
              label="Passwort"
              label-for="passwordInput"
            >
              <b-form-input
                id="passwordInput"
                type="password"
                v-model="form.password"
                required
              ></b-form-input>
            </b-form-group>
            <b-form-group>
              <b-alert
                dismissible
                @dismissed="error = ''"
                variant="danger"
                :show="errorMessage.length > 0"
              >
                {{ errorMessage }}
              </b-alert>
            </b-form-group>
            <b-row class="text-left" align-v="center">
              <b-col>
                <a href="/reset-password">Passwort vergessen</a>
              </b-col>
              <b-col class="text-right">
                <b-button type="submit" variant="primary" :disabled="isLoading">
                  <b-spinner small v-show="isLoading" />
                  Einloggen
                </b-button>
              </b-col>
            </b-row>
          </b-form>
        </b-jumbotron>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { authMixin } from "../mixins/auth";

export default {
  name: "Login",
  mixins: [authMixin],
  data: function() {
    return {
      form: {
        email: "",
        password: ""
      },
      errorMessage: "",
      isLoading: false
    };
  },
  methods: {
    doLogin: function() {
      this.errorMessage = "";
      this.isLoading = true;
      const data = new FormData();
      data.append("email", this.form.email);
      data.append("password", this.form.password);
      this.$http
        .post("user/token", data)
        .then(response => {
          this.login(response.data.data);
        })
        .catch(error => {
          this.errorMessage = error.response.data.message;
        })
        .finally(() => (this.isLoading = false));
    }
  }
};
</script>
